module.exports = {"540630101":"措折罗玛镇","540630200":"协德乡","540630201":"雅曲乡","540630202":"嘎措乡","540630203":"措折强玛乡","540630204":"多玛乡","540630205":"巴岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540630.json
// module id = 2745
// module chunks = 0